import { AjaxWrapper, HttpMethod } from '../../../services/ajaxWrapper'
import { StateKey, StateManager } from '../../../services/state'

import * as Types from './types'
import * as Utils from './utils'
declare const RASA_SELF_SERVICE_API;

export const fetchStatsData = (viewState: Types.ViewState) => {
  const community: string = StateManager.getValue(StateKey.COMMUNITY)
  const url: string = `${RASA_SELF_SERVICE_API}/dataset/${community}/elasticsearch?index=email-events`
  const payload: any = Utils.searchPayload(viewState)
  return AjaxWrapper.ajax(url, HttpMethod.POST, payload)
}

